// pages/TarifaSupervision/datagrid/columnsAvisosPend.js
import moment from "moment";
import "moment/locale/es"; // asegura nombres en español

const formatMoney = (value) =>
  new Intl.NumberFormat("es-HN", {
    style: "decimal",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(Number.parseFloat(value) || 0);

export const columnsAvisosPend = [
  {
    field: "id",
    headerName: "Aviso Cobro",
    flex: 1,
    headerAlign: "center",
    align: "center",
    cellClassName: "name-column--cell",
  },
  {
    field: "Servicio",
    headerName: "Servicio",
    flex: 2,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "FechaEmision",
    headerName: "Fecha Emitido",
    flex: 1,
    headerAlign: "center",
    align: "center",
    valueFormatter: (params) => (params?.value ? moment(params.value).utc().format("LL") : ""),
  },
  {
    field: "Formato",
    headerName: "Moneda",
    flex: 1,
    headerAlign: "center",
    align: "center",
  },
  {
    field: "Monto",
    headerName: "Monto",
    flex: 1,
    headerAlign: "center",
    align: "center",
    valueFormatter: (params) => formatMoney(params.value),
  },
];
